export const MINIMUM_FIELDS_WITH_REQUIRED_VALUES = 6;
